﻿'use strict';

/**
 * @ngdoc service
 * @name ntmApp.ListGridStatus
 * @description
 * # ListGridStatus
 * Service in the ntmApp.
 */

angular.module('ntmApp')
  .factory('ListGridStatus', ['ListGridConstants', function (ListGridConstants) {

      var status = {};

      status.editType = ListGridConstants.EditType.DIALOG;
      status.gridId = null;
      status.htmlPageId = null;
      status.columns = [];
      status.actions = { rowActions: [] };
      status.gridSettings = {};
      status.grid = {};
      status.originalGridData = [];
      status.gridApi = null;

      return status;

  }]);